import { forwardRef, useImperativeHandle } from 'react'
import { useDisclosure } from '@mantine/hooks'
import { Modal, Title, type TitleOrder } from '@mantine/core'
import { sendSignal } from '@shared/port-send-v1.0.0'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const [opened, { open, close }] = useDisclosure(false)
	useImperativeHandle(
		ref,
		() => ({
			open() {
				open()
			},
			close() {
				close()
			},
		}),
		[]
	)

	return (
		<Modal.Root
			onClose={() => {
				close()
				sendSignal(p.noodlNode, 'closed')
			}}
			{...p}
			size={p.modalSizeUnits || p.modalSizePresets}
			opened={opened}
			{...p.customProps}
		>
			<Modal.Overlay opacity={p.modalOpacity} blur={p.modalBlur} />
			<Modal.Content>
				{p.modalHeader && (
					<Modal.Header>
						{p.modalTitle && (
							<Modal.Title>
								<Title order={Number.parseInt(p.modalTitleOrder) as TitleOrder}>{p.modalTitle}</Title>
							</Modal.Title>
						)}
						{p.closeAction && <Modal.CloseButton />}
					</Modal.Header>
				)}
				<Modal.Body>{p.children}</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	)
})
